// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"1483":"03d6c8be","3182":"398ea505","4888":"623ad012","5271":"961218a6"}[chunkId] + ".css";
};